import { API_URL } from '../../api/client';
import { Plot } from '../../models/Plot';
import { Plots } from '../../models/Plots';
import { PlotsRow } from '../../models/PlotsRow';
import './plots.css';

interface PlotsComponentProps {
   plots: Plots | null;
}

const PlotsComponent = (props: PlotsComponentProps): React.JSX.Element => {
   const get_metric_name = (row: PlotsRow): string => {
      if (row.metric_label) return row.metric_label;
      if (row.violin_plot) {
         const plot: Plot = row.violin_plot;
         const title_split = plot.title.split(' ');
         return title_split[0];
      } else if (row.stats_plot) {
         const plot: Plot = row.stats_plot;
         const title_split = plot.title.split(' ');
         return title_split[0];
      } else {
         return 'Unknown Metric';
      }
   };
   /* eslint-disable @typescript-eslint/no-unsafe-assignment */
   /* eslint-disable @typescript-eslint/no-unsafe-member-access */
   /* eslint-disable @typescript-eslint/no-unsafe-call */
   /* eslint-disable @typescript-eslint/restrict-template-expressions */
   return (
      <>
         {props.plots ? (
            <div className="plots-container">
               {/* Metric Plots - One row per metric with meaningful organization */}
               <div className="metrics-section">
                  {props.plots.rows.map((row: PlotsRow, index: number) => {
                     if (!row.violin_plot && !row.stats_plot) return null;
                     return (
                        <div
                           className="metric-row"
                           data-has-violin={row.violin_plot !== null}
                           data-has-stats={row.stats_plot !== null}
                           key={index}
                        >
                           <div className="metric-name" title={row.metric_description || undefined}>
                              {get_metric_name(row)}
                           </div>

                           {row.violin_plot !== null && (
                              <div className="plot-item">
                                 <img
                                    src={`${API_URL}/${row.violin_plot.url}`}
                                    className="violin-plot-image"
                                    alt={row.violin_plot.description}
                                    loading="lazy"
                                 />
                              </div>
                           )}

                           {row.kde_plot !== null && (
                              <div className="plot-item">
                                 <img
                                    src={`${API_URL}/${row.kde_plot.url}`}
                                    className="violin-plot-image"
                                    alt={row.kde_plot.description}
                                    loading="lazy"
                                 />
                              </div>
                           )}

                           {row.stats_plot !== null && (
                              <div className="stats-plot-item">
                                 <img
                                    src={`${API_URL}/${row.stats_plot.url}`}
                                    className="confidence-plot-image"
                                    alt={row.stats_plot.description}
                                    loading="lazy"
                                 />
                              </div>
                           )}
                        </div>
                     );
                  })}
               </div>
            </div>
         ) : (
            <>
               <div className="no-plots-message">
                  <div className="no-plots-icon">📊</div>
                  <div>No statistical plots are available for this entry.</div>
               </div>
            </>
         )}
      </>
   );
};

export default PlotsComponent;
